import { render, staticRenderFns } from "./ManageScheduleItemContentCategory.vue?vue&type=template&id=64918f56&scoped=true&"
import script from "./ManageScheduleItemContentCategory.vue?vue&type=script&lang=js&"
export * from "./ManageScheduleItemContentCategory.vue?vue&type=script&lang=js&"
import style0 from "./ManageScheduleItemContentCategory.vue?vue&type=style&index=0&id=64918f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64918f56",
  null
  
)

export default component.exports